// Sentry must be initialized before any other imports
import './instrument'
import { reloadAfterPreloadError } from './utils/preloadReload'

// When a new deploy replaces chunk hashes, lazy-loaded modules 404.
// Reload so the user gets the new build instead of a broken page, but at most
// once a minute: a chunk missing from the new build too would otherwise loop.
window.addEventListener('vite:preloadError', () => {
  let storage: Storage
  try {
    // Reading the property throws where storage is blocked.
    storage = window.sessionStorage
  } catch {
    return
  }
  reloadAfterPreloadError(storage, () => window.location.reload())
})

import * as Sentry from '@sentry/react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import { AuthProvider } from '@/contexts/AuthContext'
import './index.css'
import { PostHogProvider } from 'posthog-js/react'

const isDev = import.meta.env.MODE === 'development'

const options = {
  api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
}

const SentryErrorFallback = () => (
  <div style={{ padding: '2rem', textAlign: 'center' }}>
    <h1>Something went wrong</h1>
    <p>The error has been reported. Please refresh the page.</p>
  </div>
)

const Root = (
  <Sentry.ErrorBoundary fallback={SentryErrorFallback}>
    {isDev ? (
      // no PostHog in development
      <AuthProvider>
        <App />
      </AuthProvider>
    ) : (
      <PostHogProvider apiKey={import.meta.env.VITE_POSTHOG_KEY} options={options}>
        <AuthProvider>
          <App />
        </AuthProvider>
      </PostHogProvider>
    )}
  </Sentry.ErrorBoundary>
)

ReactDOM.createRoot(document.getElementById('root')!).render(Root)
